import { themeGoldNugget } from "./gold-nugget.js";
import { themePinkPulse } from "./pink-pulse.js";
import { themePurpleStardust } from "./purple-stardust.js";
const themeColorPresets = {
  [themeGoldNugget.id]: themeGoldNugget,
  [themePinkPulse.id]: themePinkPulse,
  [themePurpleStardust.id]: themePurpleStardust
};
export {
  themeColorPresets,
  themeGoldNugget,
  themePinkPulse,
  themePurpleStardust
};
